import { render, staticRenderFns } from "./PremiumFeatures.vue?vue&type=template&id=c11a1f3e&"
import script from "./PremiumFeatures.vue?vue&type=script&lang=js&"
export * from "./PremiumFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports